import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../store/actions';
import { useIsAdmin } from './useIsAdmin';

export const useAdminRole = () => {
    const isAdmin = useIsAdmin();
    const dispatch = useDispatch();

    useEffect(() => {
        if (isAdmin) {
            dispatch(actions.userSetAttributesAction({ role: 'admin' }));
        }
    }, [isAdmin, dispatch]);
};
